import {Component} from 'substance'

class UnsupportedInlineNodeComponent extends Component {
    render($$) {
        var node = this.props.node;
        var el = $$('div')
            .addClass('dw-unsupported-inline-node')
            .attr('data-id', node.id)

        el.append(`Unsupported <${node.tagName}>`)
        return el
    }
}

export {UnsupportedInlineNodeComponent}
